import { useSelector } from 'react-redux';
import { login } from '../../../store/auth/auth-actions';
import iconsList from '../icons/iconsList';
import Button from './Button';
import classes from './Button.module.scss' 

const IdentifyButton = ({ bgcolor, text, icon, className, ...props }) => {

  const { texts } = useSelector(state => state.translate);
  const onClick = () => { login() }

  return (
    <Button
      onClick={onClick}
      color={bgcolor || '#070C43'}
      text={text || texts["btnIdentify"]}
      iconName={icon || iconsList.key}
      className={`${classes.identifyButton} ${className || ""}`}
      {...props}
    />
  );
};

export default IdentifyButton;

